import { FontWeight, ITheme, mediaQuery } from '@quicktools/shared-components/styles';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  ({ breakpoints }: ITheme) => ({
    root: {
      alignItems: 'flex-end',
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',

      [mediaQuery(breakpoints.tablet)]: {
        alignItems: 'center',
        flexDirection: 'column',
      },
    },
    group: {
      width: 'calc((100% - 32px) / 2)',

      [mediaQuery(breakpoints.tablet)]: {
        width: '100%',
      },
    },
    icon: {
      cursor: 'pointer',
      marginBottom: 8,
      marginInline: 16,

      '&:hover circle': {
        borderRadius: '50%',
        fill: '#e8e8e8',
      },

      [mediaQuery(breakpoints.tablet)]: {
        marginTop: 12,

        '& circle': {
          borderRadius: '50%',
          fill: '#e8e8e8',
        },
      },
    },
    dropDown: {
      height: 48,

      '& > span': {
        zIndex: 0,
        height: 48,
        border: '2px solid #E7E7E7 !important',
        borderRadius: '12px !important',
        padding: '12px 16px !important',
        fontSize: '14px !important',
        lineHeight: '20px',
        fontWeight: '500 !important',
        '& > span': {
          marginLeft: 'auto',
        },
      },
      marginTop: 4,
    },
    popoverClass: {
      '& li': {
        fontWeight: FontWeight.Medium,
      },
    },
    error: {
      '& > span': {
        border: '2px solid var(--x-error-color) !important',
      },
    },
    button: {
      backgroundColor: 'var(--x-bg-12) !important',
    },
  }),
  { name: 'TranslatorDropdowns' },
);
export default useStyles;
